<template>
  <div>
    <div class="margin">
      <div class="pr">
        <input class="input input_theme" @input="setTheme($event.target.value)" v-model="theme" :placeholder="'主题' + this.boxid + '名称，备注用'" />
        <button class="ctheme" @click="clearCacheTheme"></button>
      </div>
    </div>

    <div class="margin div">
      <div class="h1">输入咒语：<button class="btn" :class="cache===true ? 'onw' : ''" @click="clearCacheCode">清除缓存</button></div>
      <div class="h2"><textarea class="codeinput" @input="setCode($event.target.value)" v-model="codeInput"></textarea></div>
    </div>

    <div class="margin div">
      <div class="fl">
        <div class="h1">SD 咒语：<button class="btn copybtn1 on" data-clipboard-action="copy" :data-clipboard-target="'#code_sd' + this.boxid" @click="copy1">复制</button></div>
        <div class="h2"><textarea :id="'code_sd' + this.boxid" class="codeinput codeinput_bg codeinput2" v-model="codeSd"></textarea></div>
      </div>

      <div class="fr">
        <div class="h1">Naifu 咒语：<button class="btn copybtn2 on" data-clipboard-action="copy" :data-clipboard-target="'#code_naifu' + this.boxid" @click="copy2">复制</button></div>
        <div class="h2"><textarea :id="'code_naifu' + this.boxid" class="codeinput codeinput_bg codeinput2" v-model="codeNaifu"></textarea></div>
      </div>

      <div class="clear"></div>
    </div>

    <div class="margin div" v-show="iflists">
      <div class="h1">咒语列表：<button class="btn copybtn3 on" data-clipboard-action="copy" :data-clipboard-target="'#code_list' + this.boxid" @click="copy3">复制</button></div>
      <div class="h2"><textarea :id="'code_list' + this.boxid" class="codeinput codeinput_bg" v-model="codeLists"></textarea></div>
    </div>

    <div class="margin div noselect"><label><input type="checkbox" v-model="ifblank" /> <span class="labtxt">逗号后加空格</span></label> &nbsp; &nbsp;<label><input type="checkbox" v-model="ifunline" /> <span class="labtxt">空格转下划线</span></label> &nbsp; &nbsp;<label><input type="checkbox" v-model="ifdelcn" /> <span class="labtxt">屏蔽中文</span></label> &nbsp; &nbsp;<span class="prb"><input class="input" type="text" @input="setBlock($event.target.value)" v-model="blockWords" placeholder="自定义屏蔽词，多个用,号分开" /><button class="z" type="checkbox" @click="blockFill">预设</button><button class="ctheme" @click="clearBlock"></button></span></div>

    <div class="margin div noselect"><label><input type="checkbox" v-model="iflists" /> <span class="labtxt">显示列表</span></label> &nbsp; &nbsp;<label v-show="iflists"><input type="checkbox" v-model="iflistsPoi" /> <span class="labtxt">列表加逗号</span></label></div>
  </div>
</template>

<script>
import Clipboard from 'clipboard';

export default {
  name: 'HtmlBox',
  data(){
    return{
      theme: '',
      codeInput: '',
      codeSd: '',
      codeNaifu: '',
      codeLists: '',
      blockWords: '',
      fillWords: '\\?, \\s+\\d+\\.*\\d*[k|m]*[\\' + 'n\\' + 'r]*',
      ifblank: true,
      ifunline: false,
      iflists: false,
      iflistsPoi: false,
      ifdelcn: false,
      cache: false,
    }
  },
  props:{
    boxid:{
      default: 0
    },
  },
  created(){
    //咒语
    let storage_code_input = this.getStorage('mantra_code_input_' + this.boxid);
    if(storage_code_input && storage_code_input!=''){
      this.codeInput = this.base64_decode(storage_code_input);
      this.setCode(this.codeInput);
      this.cache = true;
    }

    //主题
    let storage_theme = this.getStorage('mantra_theme_' + this.boxid);
    if(storage_theme && storage_theme!=''){
      this.theme = storage_theme;
    }

    //逗号后加空格
    let storage_ifblank = this.getStorage('mantra_ifblank_' + this.boxid);
    if(storage_ifblank==0){this.ifblank = false;}

    //下划线代替空格
    let storage_ifunline = this.getStorage('mantra_ifunline_' + this.boxid);
    if(storage_ifunline==1){this.ifunline = true;}

    //显示列表
    let storage_iflists = this.getStorage('mantra_iflists_' + this.boxid);
    if(storage_iflists==1){this.iflists = true;}

    //列表加逗号
    let storage_iflistsPoi = this.getStorage('mantra_iflistsPoi_' + this.boxid);
    if(storage_iflistsPoi==1){this.iflistsPoi = true;}

    //屏蔽中文
    let storage_ifdelcn = this.getStorage('mantra_ifdelcn_' + this.boxid);
    if(storage_ifdelcn==1){this.ifdelcn = true;}

    //屏蔽词
    let storage_blockWords = this.getStorage('mantra_blockWords_' + this.boxid);
    if(storage_blockWords && storage_blockWords!=''){this.blockWords = storage_blockWords;}
  },
  methods: {
    copy1(){
      new Clipboard('.copybtn1');
    },
    copy2(){
      new Clipboard('.copybtn2');
    },
    copy3(){
      new Clipboard('.copybtn3');
    },
    base64_encode(str){
      if(str){
        let encode = encodeURI(str);
        let base64 = btoa(encode);
        return base64;
      }
    },
    base64_decode(base64){
      if(base64){
        let decode = atob(base64);
        let str = decodeURI(decode);
        return str;
      }
    },
    setStorage(key, value){
      localStorage.setItem(key, value);
    },
    getStorage(key){
      let value = localStorage.getItem(key);
      if(value && value!=''){
        return value;
      }
    },
    clearCacheTheme(){
      this.setStorage('mantra_theme_' + this.boxid, '');
      this.theme = '';
    },
    clearBlock(){
      this.setStorage('mantra_blockWords_' + this.boxid, '');
      this.blockWords = '';
    },
    clearCacheCode(){
      let msg = '确定要清除缓存吗？';
      if(confirm(msg)===true){
        this.setStorage('mantra_code_input_' + this.boxid, '');
        this.cache = false;
        this.codeInput = '';
        this.codeSd = '';
        this.codeNaifu = '';
        this.codeLists = '';
      }
    },
    setTheme(theme){
      if(theme){
        this.setStorage('mantra_theme_' + this.boxid, theme);
      }
    },
    setCode(code){
      if(code){
        this.codeInput = code;
        this.setStorage('mantra_code_input_' + this.boxid, this.base64_encode(code));
        this.cache = true;
        this.codeSd = this.changeCode(code, 'sd');
        this.codeNaifu = this.changeCode(code, 'naifu');
        this.codeLists = this.listsCode(code);
      }
    },
    delNote(code){
      code = code.replace(/\/\/.*[\w\r\n]?/g, '');
      code = code.replace(/\/\*[\r\n]*[\s\S]*?[\r\n]*\*\//g, '');
      return code;
    },
    delBlock(code, words){
      if(words=='' || !words){
        return code;
      }
      words = words.replace(/，/g, ',');
      let arr = words.split(',');
      arr = this.delArrEmpty(arr);
      for(let i=0; i<arr.length; i++){
        let aw = arr[i].trim();
        try{
          let reg = new RegExp(aw, 'g');
          code = code.replace(reg, '');
        }catch{
          null;
        }
      }
      return code;
    },
    blockFill(){
      this.blockWords += (this.blockWords!='' ? ', ' : '') + this.fillWords;
      this.setStorage('mantra_blockWords_' + this.boxid, this.blockWords);
    },
    changeCode(code, codetype){
      code = code.toLowerCase();
      code = code.trim();
      code = this.delNote(code);  //去除注释
      code = code.replace(/[\r\n]/g, ',');  //去除回车
      code = code.replace(/：/g, ':');
      code = code.replace(/（/g, '(');
      code = code.replace(/）/g, ')');
      code = code.replace(/，/g, ',');
      code = code.replace(/｛/g, '{');
      code = code.replace(/｝/g, '}');
      code = code.replace(/。/g, '');
      if(this.ifdelcn===true){
        code = code.replace(/[\u4e00-\u9fa5]/g, '');
      }
      if(this.blockWords && this.blockWords!=''){
        code = this.delBlock(code, this.blockWords);
      }
      code = code.replace(/(\s+)/g, ' ');
      code = code.replace(/\(\)/g, '');  //空括号

      if(codetype=='sd'){
        code = code.replace(/\{/g, '(');
        code = code.replace(/\}/g, ')');
      }
      if(codetype=='naifu'){
        code = this.sdSyntax(code);
        code = code.replace(/\(/g, '{');
        code = code.replace(/\)/g, '}');
      }

      //括号之间的前后空格去掉
      code = code.replace(/\(\s/g, '(');
      code = code.replace(/\s\)/g, ')');
      code = code.replace(/\{\s/g, '{');
      code = code.replace(/\s\}/g, '}');

      let arr = code.split(',');
      arr = this.delArrEmpty(arr);

      let newcode = '';
      for(let i=0; i<arr.length; i++){
        newcode = newcode + this.strFormat(arr[i], this.ifunline) + ',' + (this.ifblank===true ? ' ' : '');
      }
      newcode = newcode.trim();
      let last = newcode.substr(-1, 1);
      if(last==','){
        newcode = newcode.substr(0, newcode.length-1);
      }

      newcode = this.lastDeal(newcode);  //最后再过滤一遍
      return newcode;
    },
    listsCode(code){
      code = code.toLowerCase();
      code = code.trim();
      code = this.delNote(code);  //去除注释
      code = code.replace(/[\r\n]/g, ',');  //去除回车
      code = code.replace(/：/g, ':');
      code = code.replace(/:\d+\.?\d*\)/g, '');
      code = code.replace(/\(/g, '');
      code = code.replace(/\)/g, '');
      code = code.replace(/（/g, '');
      code = code.replace(/）/g, '');
      code = code.replace(/\{/g, '');
      code = code.replace(/\}/g, '');
      code = code.replace(/｛/g, '');
      code = code.replace(/｝/g, '');
      code = code.replace(/，/g, ',');
      code = code.replace(/。/g, '');
      if(this.ifdelcn===true){
        code = code.replace(/[\u4e00-\u9fa5]/g, '');
      }
      if(this.blockWords && this.blockWords!=''){
        code = this.delBlock(code, this.blockWords);
      }
      code = code.replace(/(\s+)/g, ' ');
      code = code.replace(/\(\)/g, '');  //空括号

      let arr = code.split(',');
      arr = this.delArrEmpty(arr);

      let newcode = '';
      for(let i=0; i<arr.length; i++){
        newcode += this.strFormat(arr[i], this.ifunline) + (this.iflistsPoi===true ? ',' : '');
        if(i != arr.length - 1){
          newcode += "\n";
        }
      }

      newcode = this.lastDeal(newcode);  //最后再过滤一遍
      return newcode;
    },
    lastDeal(code){
      let reg = new RegExp('['+(this.ifdelcn===true ? '' : '\u0391-\uFFE5')+'A-z0-9-_\\()\'":.^+.%$~@!?#&|;*{}<>\\[\\]\\s,\\/\\r\\n]', 'g');
      let match = code.match(reg);
      code = match.join('');
      return code;
    },
    setBlock(words){
      this.blockWords = words;
      this.setStorage('mantra_blockWords_' + this.boxid, this.blockWords);
    },
    sdSyntax(code){  //SD特有语法
      let reg = /\([A-z0-9\s-_]+:\d+\.?\d*\)/g;
      let matchcode = code.match(reg);
      if(matchcode && matchcode.length>0){
        for(let i=0; i<matchcode.length; i++){
          let matchcode2 = matchcode[i].match(/:\d+\.?\d*/);
          let codenum = Number(matchcode2[0].replace(':', ''));

          ///////////////////////////
          let counts = 0;
          let star = 1;
          let step = 1.05;
          while(star < codenum){
            star = star * step;
            counts++;
          }
          counts--;
          ///////////////////////////

          let newSyntax = matchcode[i].replace('(', '');
          newSyntax = newSyntax.replace(')', '');
          newSyntax = newSyntax.replace(/:\d+\.?\d*/, '');
          let l = '';
          let r = '';
          for(let y=0; y<counts; y++){
            l += '{';
            r += '}';
          }
          newSyntax = l + newSyntax + r;

          code = code.replace(matchcode[i], newSyntax);
        }
      }
      return code;
    },
    delArrEmpty(arr){  //数组去空
      for(let i=0; i<arr.length; i++){
        if(arr[i]=='' || arr[i]==' ' || arr[i]==null || typeof(arr[i])=='undefined' || arr[i]=='　'){
          arr.splice(i, 1);
          i = i-1;
        }
      }
      return arr;
    },
    strFormat(str, ifunline){
      str = str.trim();
      if(ifunline===true){
        str = str.replace(/\s/g, '_');
      }
      return str;
    },
  },
  watch: {
    ifblank(){
      this.setCode(this.codeInput, 'sd');
      this.setCode(this.codeInput, 'naifu');
      this.setStorage('mantra_ifblank_' + this.boxid, (this.ifblank===true ? 1 : 0));
    },
    ifunline(){
      this.setCode(this.codeInput, 'sd');
      this.setCode(this.codeInput, 'naifu');
      this.setStorage('mantra_ifunline_' + this.boxid, (this.ifunline===true ? 1 : 0));
    },
    iflists(){
      this.setStorage('mantra_iflists_' + this.boxid, (this.iflists===true ? 1 : 0));
    },
    iflistsPoi(){
      this.codeLists = this.listsCode(this.codeInput);
      this.setStorage('mantra_iflistsPoi_' + this.boxid, (this.iflistsPoi===true ? 1 : 0));
    },
    ifdelcn(){
      this.setCode(this.codeInput, 'sd');
      this.setCode(this.codeInput, 'naifu');
      this.setStorage('mantra_ifdelcn_' + this.boxid, (this.ifdelcn===true ? 1 : 0));
    },
    blockWords(){
      this.setCode(this.codeInput, 'sd');
      this.setCode(this.codeInput, 'naifu');
    },
  }
}
</script>

<style scoped>
.codeinput {width: 100%; height: 280px; border: 1px solid #767676; box-sizing: border-box; padding: 5px 10px; font-size: 14px; resize: vertical; min-height: 40px;}
.codeinput_bg {background-color: #e7e7e7;}
.codeinput2 {height: 120px;}
.input, .codeinput {-webkit-transition: 0.1s ease-in; transition: 0.1s ease-in; transition-property: box-shadow,border-color;}
.input:focus, .codeinput:focus {border-color: #7a9cd3; box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(122, 156, 211, 0.6);}
.div {padding-top: 14px; font-size: 15px; line-height: 26px;}
.div .h1 {font-size: 15px; padding-bottom: 6px;}
.div .fl, .div .fr {width: calc(50% - 8px);}
.div .fl {float: left;}
.div .fr {float: right;}
.clear {clear: both;}
.btn {border-radius: 5px; background-color: #e7e7e7; color: #222; border: 1px solid #ddd; padding: 8px 20px;}
.btn:hover {box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.4);}
.btn.on {background-color: #3a97ef; color: #fff; border: 1px solid #3a97ef;}
.btn.onw {background-color: #e76b6b; color: #fff; border: 1px solid #e76b6b;}
.noselect {user-select: none;}
.input {width: 320px; height: 32px; box-sizing: border-box; font-size: 15px; padding: 0 8px; border: 1px solid #767676;}
.input_theme {width: 100%; background-color: #e7e7e7; font-weight: bold; text-align: center; color: #3a97ef;}
.input::placeholder {color: #999; font-weight: normal;}
.ctheme {width: 20px; height: 20px; line-height: 20px; background-color: #fff; border: 1px solid #ccc; position: absolute; top: 6px; right: 8px; border-radius: 50%; z-index: 2; cursor: pointer;}
.ctheme:before, .ctheme:after {content: ""; display: block; width: 11px; height: 1px; background-color: #999; position: absolute; top: 9px; left: 4px;}
.ctheme:before {transform: rotate(45deg);}
.ctheme:after {transform: rotate(-45deg);}
.ctheme:hover {background-color: #e76b6b; border-color: #e76b6b;}
.ctheme:hover:before, .ctheme:hover:after {background-color: #fff;}
.labtxt {display: inline-block; vertical-align: middle;}
.prb {position: relative; display: inline-block;}
.prb .z {position: absolute; top: 6px; right: 38px; padding: 0 6px;}
@media (max-width: 760px) {
  .prb {width: 100%; display: block; margin-top: 5px;}
  .prb .input {width: 100%;}
}
</style>